import React from "react";
import "./Sidebar.css";
import HomeIcon from "../../assets/icons/Home.svg";
import InfoIcon from "../../assets/icons/Info.svg";
import IdeaValidatorIcon from "../../assets/icons/IdeaValidator.svg";
import MarketInsightsIcon from "../../assets/icons/MarketInsights.svg";
import PitchDeckAnalyzerIcon from "../../assets/icons/PitchDeckAnalyzer.svg";
import { strings } from "../../translations/strings";

const Sidebar = ({ data }) => {
  const { SCREENS, colors, isMenuOpened, currentScreen, onPressSidebarItem } =
    data;
  const MobileItems = [
    { image: HomeIcon, screen: SCREENS.HOME, title: strings.home_tab },
    { image: InfoIcon, screen: SCREENS.INFO, title: strings.learn_more_tab },
    {
      image: IdeaValidatorIcon,
      screen: SCREENS.IDEA_VALIDATOR,
      title: strings.idea_validator_tab,
    },
    {
      image: MarketInsightsIcon,
      screen: SCREENS.MARKET_INSIGHTS,
      title: strings.market_insights_tab,
    },
    {
      image: PitchDeckAnalyzerIcon,
      screen: SCREENS.PITCH_DECK_ANALYZER,
      title: strings.pitch_deck_analyzer_tab,
    },
  ];
  const DesktopItems = MobileItems?.slice(0, 2);

  return (
    <div
      className="sidebar-container"
      style={{ backgroundColor: colors.componentBackground }}
    >
      <div className="sidebar-desktop-content">
        {DesktopItems?.map((item) => {
          return (
            <div
              className="sidebar-item"
              onClick={() => onPressSidebarItem(item?.screen)}
              key={item?.screen}
            >
              <img
                alt={item?.title}
                src={item?.image}
                height={36}
                width={36}
                draggable={false}
              />
              {isMenuOpened && (
                <span
                  className="sidebar-item-text"
                  style={{ color: colors.sidebarText }}
                >
                  {item?.title}
                </span>
              )}
            </div>
          );
        })}
      </div>
      <div className="sidebar-mobile-content">
        {MobileItems?.map((item) => {
          return (
            <div
              className={`sidebar-item ${
                currentScreen === item?.screen ? "choosen" : ""
              } `}
              onClick={() => onPressSidebarItem(item?.screen)}
              key={item?.screen}
            >
              <img
                alt={item?.title}
                src={item?.image}
                height={36}
                width={36}
                style={{ borderRadius: "50%" }}
                draggable={false}
              />
              {isMenuOpened && (
                <span
                  className="sidebar-item-text"
                  style={{ color: colors.primaryText }}
                >
                  {item?.title}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Sidebar;
